import { UNIT_CONVERSION_SCALE } from "../../../constants/values";

export const convertToPicocuries = (bqm) => {
  const pCiL = bqm / UNIT_CONVERSION_SCALE;

  const fixed = Math.round(pCiL * 10) / 10;
  const parsedValue = parseFloat(fixed.toFixed(1));

  return parsedValue;
};

export const getRadonValue = (measurementUnit, BqmValue) => {
  if (BqmValue) {
    switch (measurementUnit) {
      case 0:
        return convertToPicocuries(BqmValue);
      case 1:
        if (BqmValue === undefined || BqmValue === "") {
          return BqmValue;
        } else {
          return parseFloat(BqmValue.toFixed(0));
        }
      default:
        return null;
    }
  } else if (BqmValue === 0) {
    return 0;
  }

  return null;
};

export function reformatRadonChartData(data, unit) {
  if (data === "") {
    return [];
  } else {
    return data.map((key, index) => {
      let radonValue = getRadonValue(unit, key);

      return {
        data_no: index + 1,
        radon_level: radonValue,
      };
    });
  }
}
